import {
  formsButtonType,
  formsLabelType,
  formsPlaceHolderType,
} from "../enums/index";
class FormTexts {
  PlaceHolders(type) {
    let result = "";
    switch (type) {
      case formsPlaceHolderType.Email():
        result = "ایمیل";
        break;
      case formsPlaceHolderType.Password():
        result = "رمز عبور";
        break;
      case formsPlaceHolderType.Search():
        result =
          "جستجو با نام، نام خانوادگی، شماره موبایل، آدرس ایمیل که با فاصله از هم جدا شده‌اند";
        break;
      case formsPlaceHolderType.Reason():
        result = "دلیل رد هویت مشترک را وارد نمایید ...";
        break;
      case formsPlaceHolderType.RejectActivation():
        result = "دلیل عدم فعال‌سازی خط";
        break;
      case formsPlaceHolderType.SendSms():
        result = "متن پیام را وارد نمایید...";
        break;
      default:
        result = "";
        break;
    }
    return result;
  }
  Labels(type) {
    let result = "";
    switch (type) {
      case formsLabelType.Name():
        result = "نام";
        break;
      case formsLabelType.Family():
        result = "نام‌خانوادگی";
        break;
      case formsLabelType.FatherName():
        result = "نام پدر";
        break;
      case formsLabelType.Gender():
        result = "جنسیت";
        break;
      case formsLabelType.NationalCode():
        result = "کد‌ملی";
        break;
      case formsLabelType.BirthDay():
        result = "تاریخ تولد";
        break;
      case formsLabelType.Mobile():
        result = "شماره موبایل";
        break;
      case formsLabelType.Email():
        result = "ایمیل";
        break;
      case formsLabelType.Phone():
        result = "تلفن ثابت";
        break;
      case formsLabelType.PostalCode():
        result = "کد پستی";
        break;
      case formsLabelType.Address():
        result = "آدرس";
        break;
        case formsLabelType.Street():
          result = "خیابان‌اصلی";
          break;
      case formsLabelType.Alley():
        result = "خیابان‌فرعی(کوچه)";
        break;
      case formsLabelType.Plaque():
        result = "پلاک";
        break;


      case formsLabelType.CompanyName():
        result = "نام شرکت";
        break;
      case formsLabelType.Occupation():
        result = "زمینه فعالیت";
        break;
      case formsLabelType.CodeNumber():
        result = "شماره ثبت";
        break;
      case formsLabelType.CompanyNationalCode():
        result = "شماره ملی";
        break;
      case formsLabelType.CompanyAddress():
        result = "آدرس شرکت";
        break;
      case formsLabelType.RejectAuthNational():
        result = "رد به دلیل نا مناسب بودن کارت ملی";
        break;
      case formsLabelType.RejectAuthPostal():
        result = "رد به دلیل ناصحیح بودن آدرس پستی";
        break;
      case formsLabelType.RejectAuthOther():
        result = "موارد دیگر";
        break;
      case formsLabelType.CompanyEconomicCode():
        result = "کد اقتصادی";
        break;
      case formsLabelType.Address():
        result = "آدرس";
        break;
      case formsLabelType.Street():
        result = "خیابان اصلی";
        break;
      case formsLabelType.Alley():
        result = "خیابان‌ فرعی(کوچه)";
        break;
      case formsLabelType.Plaque():
        result = "پلاک";
        break;
      case formsLabelType.City():
        result = "شهر";
        break;
      case formsLabelType.Province():
        result = "استان";
        break;
      default:
        result = "";
        break;
    }
    return result;
  }
  Buttons(type) {
    let result = "";
    switch (type) {
      case formsButtonType.Enter():
        result = "ورود";
        break;
      case formsButtonType.Search():
        result = "جستجو";
        break;
      case formsButtonType.Accept():
        result = "تایید کردن";
        break;
      case formsButtonType.Inquire():
        result = "استعلام هویت";
        break;
      case formsButtonType.Reject():
        result = "رد کردن";
        break;
      case formsButtonType.Show():
        result = "مشاهده";
        break;
      case formsButtonType.AddNote():
        result = "ذخیره";
        break;
      case formsButtonType.RejectActivation():
        result = "عدم فعال‌سازی خط";
        break;
      case formsButtonType.SendSms():
        result = "ارسال پیامک";
        break;
      case formsButtonType.Send():
        result = "ارسال";
        break;
      default:
        result = "";
        break;
    }
    return result;
  }
  Gender(type) {
    let result = "";
    switch (type) {
      case 1:
        result = "زن";
        break;
      case 2:
        result = "مرد";
        break;
      default:
        result = "";
        break;
    }
    return result;
  }
}
export default new FormTexts();
